















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import MobileMixin from "@/mixins/mobileMixin";
import FecUtils from "../utils/FecUtils";
import { Groupe, Societe } from "@/shared/Groupe";
import moment from "moment/moment";
import TicketsUtils from "../utils/TicketsUtils";
import DateType from "@/shared/DateType";
import TicketMixin from "@/mixins/ticketsMixin";
import { Site } from "@/shared/Site";
import ErrorMixin from "@/mixins/errorMixins";
import ExpandableListeSites from "@/components/expansion/expandableListeSites.vue";
import ExpandableDateChooser from "@/components/expansion/expandableDateChooser.vue";
import axios from "@/plugins/axios";
import _ from "lodash";
import ListSitesExport from "@/components/listSitesExport.vue";
import FecMixin from "@/mixins/fecMixin";

@Component({
  components: { ListSitesExport, ExpandableListeSites, ExpandableDateChooser },
})
export default class Fec extends mixins(
  MobileMixin,
  ErrorMixin,
  TicketMixin,
  FecMixin
) {
  public filter: { [k: string]: any } = {};
  public dates = [
    new Date().toISOString().substr(0, 10),
    new Date().toISOString().substr(0, 10),
  ];
  public currentEnseigne: string = "";
  public dateFiscale = 0;
  public dateType: DateType = new DateType();
  public selectedSites: Site[] = [];
  public sitesCreated: Site[] = [];
  public loading: boolean = false;
  public isDownload: boolean = false;
  public isUpdated: boolean = false;
  public headers: any = [];
  public message: string = "";
  public mesFiltres = new Array();
  public parLocalisation: boolean = false;
  public isSolidLiquid: boolean = false;
  public isSolidLiquidProfit: boolean = false;
  public isHTTVA: boolean = false;
  public updatedSearchCrit = false;
  public lineIndex = 0;
  public menuF = false;
  public menuD = false;
  public onModifying: boolean = false;
  public siteSelected: any;
  public siteCreatedSelected: any;
  public currentSite: string = "";
  public dataSiteSelected: any = {};
  public dataPreconfig: any = {};
  public canModify: boolean = false;
  public modificationEntete: string = "";
  public isMultipleDate: boolean = false;
  public dialogTxt: boolean = false;
  public dialogCsv: boolean = false;
  public dialogConfigExported: boolean = false;
  public parComptage: boolean = false;
  public importConfigData: any = null;
  public fileEmpty: boolean = false;
  public canImport: boolean = false;
  public idPreconfigList: number[] = [];
  public diffData: any[] = [];
  public showChanges: boolean = false;
  public isSingleSite: boolean = false;
  public stickyCard = null as number | null;
  public stickyStyle = "position: sticky; top: 126px;";
  public refsAvailable = false;
  public isAggregateLines = false;

  public async mounted() {
    await TicketsUtils.getFilters().then((data: any) => {
      this.mesFiltres = data;
    });
    this.filter["RESTAURANT_ID"] = [];
    this.filter["LIB_SITE"] = [];

    this.mesFiltres.forEach((filtre: any) => {
      if (["RESTAURANT_ID", "LIB_SITE"].includes(filtre.cle)) {
        filtre.format = "CHOIX_MULTIPLE";
      }
      if (filtre.mandatory || filtre.cle === "RESTAURANT_ID") {
        switch (filtre.cle) {
          case "DOCUMENT":
            this.filter["DOCUMENT"] = "TICKET";
            break;
          case "DATE_FIN":
          case "DATE_DEBUT":
            this.filter[filtre.cle] = moment().format("YYYY-MM-DD");
            break;
          case "RESTAURANT_ID":
            this.filter["RESTAURANT_ID"] = [this.sites[0].restaurantId];
            break;
          case "LIB_SITE":
            this.filter["LIB_SITE"] = [this.sites[0].libelle];
            break;
          default:
            switch (filtre.format) {
              case "MONETAIRE":
                this.filter[filtre.cle] = 0;
                break;
              case "BOOLEAN":
                this.filter[filtre.cle] = true;
                break;
              default:
                this.filter[filtre.cle] = "";
                break;
            }
            break;
        }
      }
    });
    this.updateHeader();
    this.$nextTick(() => {
      this.checkRefsAvailable();
    });

    window.addEventListener("resize", this.updateStickyStatus);
  }

  public beforeDestroy() {
    window.removeEventListener("resize", this.updateStickyStatus);
    this.refsAvailable = false;
  }

  public async init(realInit: boolean = true) {
    this.checkRole();
    await this.getPreconfigList();
    const startDate = new Date(this.dates[0]);
    if (realInit) {
      startDate.setDate(startDate.getDate() - 1);
    }
    if (this.fecRestaurantId) {
      const siteFromRecurence: any = this.sites.find(
        (site) => site.restaurantId === this.fecRestaurantId
      );
      this.addSite(siteFromRecurence);
      this.$store.dispatch("config/setFecRestaurantId", null);
    }
  }

  /**
   * Les fonction "checkRefsAvailable" et "updateStickyStatus"
   * permettent de comparer les hauteurs des tableaux par rapport à l'écran de l'utilisateur
   */
  public checkRefsAvailable() {
    this.$nextTick(() => {
      const card1 = this.$refs.card1 as Vue | undefined;
      const card2 = this.$refs.card2 as Vue | undefined;

      if (card1 && card2) {
        this.refsAvailable = true;
        this.updateStickyStatus();
      } else {
        setTimeout(() => {
          this.checkRefsAvailable();
        }, 100);
      }
    });
  }

  public updateStickyStatus() {
    if (!this.refsAvailable) {
      console.warn("Les références ne sont pas encore prêtes.");
      return;
    }

    // console.log("calcule de la fenêtre...");

    const card1Ref = this.$refs.card1 as Vue | undefined;
    const card2Ref = this.$refs.card2 as Vue | undefined;

    if (!card1Ref || !card2Ref) {
      return;
    }

    const card1 = card1Ref.$el as HTMLElement;
    const card2 = card2Ref.$el as HTMLElement;

    if (!card1 || !card2) {
      return;
    }

    const card1Height = card1.getBoundingClientRect().height;
    const card2Height = card2.getBoundingClientRect().height;
    const viewportHeight = window.innerHeight;

    if (card2Height > viewportHeight) {
      this.stickyCard = null;
    } else if (card1Height > card2Height) {
      this.stickyCard = 2;
    } else {
      this.stickyCard = 1;
    }
  }

  public addSite(site: Site) {
    this.selectedSites = [site];
    this.filter.RESTAURANT_ID = [site.restaurantId];
    this.filter.LIB_SITE = [site.libelle];
    this.updatedSearchCrit = true;
    this.selectSite(site);
    this.message = this.$t("Update").toString();
  }

  public removeAllSites() {
    this.selectedSites = [];
    this.filter.RESTAURANT_ID = [];
    this.filter.LIB_SITE = [];
    this.message = this.$t("Update").toString();
  }

  public updateHeader() {
    if (this.client === "TOTAL") {
      this.headers = this.getTotalTicketHeaders();
    } else {
      this.headers = this.generateHeader();
    }
  }

  public checkRole() {
    if (this.sites.length === 1) {
      this.isSingleSite = true;
      this.selectSite(this.sites[0]);
    }
    if (this.me.droits.includes("FEC_CONFIGURATION")) {
      this.canModify = true;
    } else {
      this.canModify = false;
    }
  }

  public async created() {
    await this.init();
  }

  public goToRecurrencesFec() {
    this.$router.push(`/fec/recurrencesfec`);
  }

  public selectSite(site: any) {
    this.siteSelected = site;
    this.currentSite = this.siteSelected.libelle;
    // console.log(this.siteSelected.restaurantId);
    if (this.enseignes.length !== 0) {
      const enseigneToFind = this.enseignes.find(
        (enseigne: any) => enseigne.restaurantId === site.restaurantId
      );

      if (enseigneToFind) {
        if (enseigneToFind.libelle == null) {
          console.error("libelle null");
          this.currentEnseigne = "Volfoni";
        } else {
          this.currentEnseigne = enseigneToFind.libelle;
        }
      } else {
        console.error("Enseigne not found");
        this.currentEnseigne = "Volfoni";
      }
    }

    this.getInfoConfig(true);
    // console.log(this.currentEnseigne);
    this.setSitesCreated();
    this.onModifying = false;
    setTimeout(() => {
      this.isDownload = true;
    }, 1000);
  }

  public async siteToAdd(site: any) {
    this.canImport = true;
    this.siteCreatedSelected = site;
    if (this.enseignes.length !== 0) {
      const enseigneToFind = this.enseignes.find(
        (enseigne: any) => enseigne.restaurantId === site
      );
      this.currentEnseigne = enseigneToFind.libelle;
    }
    await this.getInfoConfig(false);
    const differences = this.compareConfigurations();
    this.diffData = differences;
  }

  public compareConfigurations() {
    const differences: any[] = [];
    const ignoredPaths = ["restaurantID", "author", "@TYPE", "groupe"];

    const isIgnoredPath = (path: string) => {
      return ignoredPaths.some((ignoredPath) => path === ignoredPath);
    };

    const compareObjects = (obj1: any, obj2: any, path: string = "") => {
      for (const key in obj1) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj1.hasOwnProperty(key)) {
          const newPath = path ? `${path}.${key}` : key;

          if (isIgnoredPath(newPath)) {
            continue;
          }

          if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
            compareArrays(obj1[key], obj2[key], newPath);
          } else if (
            typeof obj1[key] === "object" &&
            obj1[key] !== null &&
            typeof obj2[key] === "object" &&
            obj2[key] !== null
          ) {
            compareObjects(obj1[key], obj2[key], newPath);
          } else if (obj1[key] !== obj2[key]) {
            differences.push({
              path: newPath,
              currentValue: obj1[key],
              newValue: obj2[key],
            });
          }
        }
      }

      // Comparer les propriétés de obj2 qui ne sont pas dans obj1
      for (const key in obj2) {
        if (obj2.hasOwnProperty(key)) {
          const newPath = path ? `${path}.${key}` : key;

          if (isIgnoredPath(newPath)) {
            // console.log("on ignore: ", newPath);
            continue;
          }

          if (!(key in obj1)) {
            differences.push({
              path: newPath,
              currentValue: undefined,
              newValue: obj2[key],
            });
          }
        }
      }
    };

    const compareArrays = (arr1: any[], arr2: any[], path: string) => {
      const maxLength = Math.max(arr1.length, arr2.length);
      for (let i = 0; i < maxLength; i++) {
        if (arr1[i] && arr2[i]) {
          compareObjects(arr1[i], arr2[i], `${path}[${i}]`);
        } else if (arr1[i] && !arr2[i]) {
          differences.push({
            path: `${path}[${i}]`,
            currentValue: arr1[i],
            newValue: undefined,
          });
        } else if (!arr1[i] && arr2[i]) {
          differences.push({
            path: `${path}[${i}]`,
            currentValue: undefined,
            newValue: arr2[i],
          });
        }
      }
    };

    const obj1Copy = JSON.parse(JSON.stringify(this.dataPreconfig));
    const obj2Copy = JSON.parse(JSON.stringify(this.dataSiteSelected));

    compareObjects(obj1Copy, obj2Copy);
    return differences;
  }

  public toogleModifying() {
    this.onModifying = true;
    // Cacher ou non la checkbox ??
    // this.isShowAgregation = this.isToAgregate(this.dataPreconfig);
  }

  public changeTypeCredit() {
    if (this.parLocalisation) {
      this.dataPreconfig["@TYPE_CREDITS"] = "PAR_PROFIT";
    } else if (this.isSolidLiquid) {
      this.dataPreconfig["@TYPE_CREDITS"] = "SOLIDE_LIQUIDE";
    } else if (this.isSolidLiquidProfit) {
      this.dataPreconfig["@TYPE_CREDITS"] = "SOLIDE_LIQUIDE_PROFIT";
    } else if (this.isHTTVA) {
      this.dataPreconfig["@TYPE_CREDITS"] = "NORMAL";
    } else {
      this.dataPreconfig["@TYPE_CREDITS"] = "NORMAL";
    }
  }

  public aggregateLines() {
    if (this.isAggregateLines) {
      this.dataPreconfig.to_aggregate = true;
    } else {
      this.dataPreconfig.to_aggregate = false;
    }
  }

  public changeTypeDebit() {
    if (this.parComptage) {
      this.dataPreconfig["@TYPE_DEBITS"] = "COMPTAGE";
    } else {
      this.dataPreconfig["@TYPE_DEBITS"] = "NORMAL";
    }
  }

  public addGroupe() {
    if (!this.dataPreconfig.groupe) {
      this.dataPreconfig.groupe = this.currentEnseigne;
    }
  }

  public handleFileUpload(files: any) {
    if (!files) {
      console.error("No files provided");
      return;
    }

    const file = files[0] || files;
    if (file && file.type === "application/json") {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        try {
          this.importConfigData = JSON.parse(e.target!.result as string);
        } catch (error) {
          console.error("Impossible de lire le fichier", error);
          this.importConfigData = null;
        }
      };
      this.fileEmpty = true;
      reader.readAsText(file);
    } else {
      console.error("fichier invalide");
    }
  }

  public applyExportedPreconfig(preconfigImporter: any) {
    this.$store.dispatch("login/setLoading", true);
    if (preconfigImporter) {
      this.dataPreconfig.comptage = preconfigImporter.comptage;
      this.dataPreconfig.debits = preconfigImporter.debits;
      this.dataPreconfig.credits = preconfigImporter.credits;
      if (preconfigImporter.TYPE_DEBITS) {
        this.parComptage = true;
      }
      if (preconfigImporter.TYPE_CREDITS) {
        this.parLocalisation = true;
      }
      this.dataPreconfig["@TYPE_CREDITS"] = preconfigImporter["@TYPE_CREDITS"];
      this.dataPreconfig["@TYPE_DEBITS"] = preconfigImporter["@TYPE_DEBITS"];

      this.parLocalisation =
        this.dataPreconfig["@TYPE_CREDITS"] === "PAR_PROFIT";
      this.parComptage = this.dataPreconfig["@TYPE_DEBITS"] === "COMPTAGE";
      this.dialogConfigExported = false;
      this.updateInfoConfig();
      this.$store.dispatch("login/setLoading", false);
    } else {
      this.setErrorFromTxt("Erreur lors de la lecture des données");
      console.error("Aucune donnée trouvée");
      this.$store.dispatch("login/setLoading", false);
    }
  }

  public updateAuthor() {
    const currentDate = new Date();
    const mins = currentDate.getMinutes();
    const formattedTime = `${currentDate.getHours()}:${
      mins < 10 ? "0" + mins : mins
    }`;
    const formattedDate = [
      currentDate.getDate().toString().padStart(2, "0"),
      (currentDate.getMonth() + 1).toString().padStart(2, "0"),
      currentDate.getFullYear(),
    ].join("-");

    const authorName: string = this.me.login;

    if (this.dataPreconfig.author !== undefined) {
      this.dataPreconfig.author.date = formattedDate;
      this.dataPreconfig.author.auteur = authorName;
      this.dataPreconfig.author.heure = formattedTime;
    } else {
      this.dataPreconfig.author = {
        date: formattedDate,
        auteur: authorName,
        heure: formattedTime,
      };
    }
    this.showAuthor();
  }

  public showAuthor() {
    if (!this.dataPreconfig.author) {
      const currentDate = new Date();
      const formattedDate = [
        currentDate.getDate().toString().padStart(2, "0"),
        (currentDate.getMonth() + 1).toString().padStart(2, "0"),
        currentDate.getFullYear(),
      ].join("-");
      this.dataPreconfig.author = {
        date: formattedDate,
        auteur: "Autogeneration",
      };
    }

    const date = this.dataPreconfig.author.date;
    const auteur = this.dataPreconfig.author.auteur;
    const heure = this.dataPreconfig.author.heure;
    if (auteur === "Autogeneration") {
      this.modificationEntete = "Configuration générée le " + date;
    } else {
      this.modificationEntete =
        "Modifiée le " + date + " " + heure + " par " + auteur;
    }
  }

  // Fonction de validation mise à jour pour gérer toutes les structures
  public areRequiredFieldsValid(data: any): boolean {
    if (!data.debits.code_journal || !data.debits.libelle_journal) {
      return false;
    }

    for (const debit of data.debits.famille_reglement) {
      if (!debit.compte) {
        return false;
      }
    }

    if (!data.credits.code_journal || !data.credits.libelle_journal) {
      return false;
    }

    const checkSubFields = (subData: any, sectionKey: string) => {
      for (const key in subData) {
        if (subData.hasOwnProperty(key)) {
          const item = subData[key];

          if (sectionKey === "NORMAL") {
            if (!item.HT || !item.HT.compte || !item.TVA || !item.TVA.compte) {
              console.error("Échec de la validation NORMAL pour la clé:", key);
              return false;
            }
          } else if (sectionKey === "SOLIDE_LIQUIDE_PROFIT") {
            for (const typeKey in item) {
              if (item.hasOwnProperty(typeKey)) {
                const typeData = item[typeKey];
                for (const rateKey in typeData) {
                  if (typeData.hasOwnProperty(rateKey)) {
                    if (!typeData[rateKey].compte) {
                      console.error(
                        "Échec de la validation SOLIDE_LIQUIDE_PROFIT pour:",
                        "Groupe:",
                        key,
                        "Type:",
                        typeKey,
                        "Taux:",
                        rateKey
                      );
                      return false;
                    }
                  }
                }
              }
            }
          } else if (sectionKey === "SOLIDE_LIQUIDE") {
            for (const rateKey in item) {
              if (item.hasOwnProperty(rateKey)) {
                if (!item[rateKey].compte) {
                  console.error(
                    "Échec de la validation SOLIDE_LIQUIDE pour:",
                    "Type:",
                    key,
                    "Taux:",
                    rateKey
                  );
                  return false;
                }
              }
            }
          } else {
            for (const rateKey in item) {
              if (item.hasOwnProperty(rateKey)) {
                if (!item[rateKey].compte) {
                  console.error(
                    "Échec de la validation",
                    sectionKey,
                    "pour:",
                    "Groupe:",
                    key,
                    "Taux:",
                    rateKey
                  );
                  return false;
                }
              }
            }
          }
        }
      }
      return true;
    };

    for (const sectionKey in data.credits.regroupement) {
      if (data.credits.regroupement.hasOwnProperty(sectionKey)) {
        const section = data.credits.regroupement[sectionKey];

        if (!checkSubFields(section, sectionKey)) {
          return false;
        }
      }
    }

    return true;
  }

  public downloadFecJson() {
    const dataCommonPreconfig = {
      comptage: this.dataPreconfig.comptage,
      debits: this.dataPreconfig.debits,
      credits: this.dataPreconfig.credits,
      TYPE_CREDITS: this.dataPreconfig["@TYPE_CREDITS"],
      TYPE_DEBITS: this.dataPreconfig["@TYPE_DEBITS"],
      groupe: this.dataPreconfig.groupe,
    };
    const data = JSON.stringify(dataCommonPreconfig);
    const blob = new Blob([data], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `preconfig_fec_${this.siteSelected.restaurantId}`;
    link.click();
    URL.revokeObjectURL(url);
  }

  public async getInfoConfig(recupNormal: boolean) {
    this.$store.dispatch("login/setLoading", true);
    console.log(
      "Récupération de la préconfiguration FEC pour le restaurant :",
      this.siteSelected.restaurantId
    );
    if (recupNormal) {
      const fecUrl = `withCredentials/fec/config/read?restaurant=${this.siteSelected.restaurantId}&groupeName=${this.currentEnseigne}`;
      return axios
        .get(fecUrl)
        .then((response) => {
          this.dataPreconfig = response.data.normal;
          this.parLocalisation =
            this.dataPreconfig["@TYPE_CREDITS"] === "PAR_PROFIT";
          this.isSolidLiquid =
            this.dataPreconfig["@TYPE_CREDITS"] === "SOLIDE_LIQUIDE";
          this.isSolidLiquidProfit =
            this.dataPreconfig["@TYPE_CREDITS"] === "SOLIDE_LIQUIDE_PROFIT";
          this.isHTTVA = this.dataPreconfig["@TYPE_CREDITS"] === "NORMAL";
          this.parComptage = this.dataPreconfig["@TYPE_DEBITS"] === "COMPTAGE";
          this.isAggregateLines =
            this.dataPreconfig.to_aggregate !== undefined &&
            this.dataPreconfig.to_aggregate !== null
              ? this.dataPreconfig.to_aggregate
              : false;
          this.showAuthor();
          this.verrifComptage();
          this.$store.dispatch("login/setLoading", false);
        })
        .catch((error) => {
          this.setErrorFromTxt(error.toString());
          console.error("Erreur lors du préconfig FEC :", error);
          this.$store.dispatch("login/setLoading", false);
        });
    } else {
      const fecURL = `withCredentials/fec/config/read?restaurant=${this.siteCreatedSelected}&groupeName=${this.currentEnseigne}`;
      return axios
        .get(fecURL)
        .then((response) => {
          this.dataSiteSelected = response.data.normal;
          this.$store.dispatch("login/setLoading", false);
        })
        .catch((error) => {
          this.setErrorFromTxt(error.toString());
          console.error("Erreur lors du préconfig FEC :", error);
          this.$store.dispatch("login/setLoading", false);
        });
    }
  }

  public async getPreconfigList() {
    const fecUrl = `withCredentials/fec/config/list`;
    return axios
      .get(fecUrl)
      .then((response) => {
        this.idPreconfigList = response.data;
        // console.log("getpreconf:", response);
      })
      .catch((error) => {
        this.setErrorFromTxt(error.toString());
        console.error("Erreur lors du préconfig FEC :", error);
        this.$store.dispatch("login/setLoading", false);
      });
  }

  public setSitesCreated() {
    if (this.client === "BK") {
      this.sitesCreated = this.sites.filter((site) =>
        this.idPreconfigList.includes(site.restaurantId)
      );
    } else {
      const enseigneFilteredIds = this.enseignes
        .filter((enseigne: any) => enseigne.libelle === this.currentEnseigne)
        .map((enseigne: any) => enseigne.restaurantId);

      const filteredIdPreconfigList = this.idPreconfigList.filter((id) =>
        enseigneFilteredIds.includes(id)
      );

      this.sitesCreated = this.sites.filter((site) =>
        filteredIdPreconfigList.includes(site.restaurantId)
      );
    }
  }

  public async synchronizeFamille() {
    this.$store.dispatch("login/setLoading", true);
    const fecUrl = `withCredentials/fec/config/synchronize?restaurant=${this.siteSelected.restaurantId}&groupeName=${this.currentEnseigne}`;
    return axios
      .get(fecUrl)
      .then((response) => {
        this.getInfoConfig(true);
        setTimeout(() => {
          this.setSuccess(
            this.synchMessage(
              response.data.famillesAjoutees,
              response.data.profitsAjoutes,
              response.data.tauxTvaAjoutes
            )
          );
        }, 2000);
        this.$store.dispatch("login/setLoading", false);
      })
      .catch((error) => {
        this.setErrorFromTxt(error.toString());
        console.error(
          "Erreur lors de la synchronization des données FEC:",
          error
        );
        this.$store.dispatch("login/setLoading", false);
      });
  }

  public synchMessage(
    familles: string[],
    profits: string[],
    tauxTva: string[]
  ): string {
    const messages = [
      this.createListMessage(
        familles,
        "famille",
        "familles",
        "la",
        "Le",
        "Les"
      ),
      this.createListMessage(profits, "profit", "profits", "le", "Le", "Les"),
      this.createListMessage(
        tauxTva,
        "taux TVA",
        "taux TVA",
        "le",
        "Le",
        "Les"
      ),
    ];

    const nonEmptyMessages = messages.filter((msg) => msg !== "");
    if (nonEmptyMessages.length === 0) {
      return "La liste des familles, profits, et taux TVA est à jour. \n";
    }

    return nonEmptyMessages.join("\n");
  }

  public createListMessage(
    items: string[],
    singular: string,
    plural: string,
    articleSingular: string,
    articleSingularCapitalized: string,
    articlePlural: string
  ): string {
    switch (items.length) {
      case 0:
        return "";
      case 1:
        return `${articleSingularCapitalized} ${singular} suivant${
          singular === "famille" ? "e" : ""
        } a été ajouté${singular === "famille" ? "e" : ""}: ${items[0]}. \n`;
      default:
        return `${articlePlural} ${plural} suivant${
          singular === "famille" ? "e" : ""
        }s ont été ajouté${singular === "famille" ? "e" : ""}s: ${items.join(
          ", "
        )}. \n`;
    }
  }

  public onUserInput() {
    this.isUpdated = true;
  }

  public cancelUpdate() {
    this.getInfoConfig(true);
    this.isUpdated = false;
    setTimeout(() => {
      this.onModifying = false;
    }, 1000);
  }

  public async updateInfoConfig() {
    this.$store.dispatch("login/setLoading", true);
    if (!this.areRequiredFieldsValid(this.dataPreconfig)) {
      this.setErrorFromTxt("Les données ne peuvent pas être vides");
      console.error("Les données ne peuvent pas être vides!");
      this.$store.dispatch("login/setLoading", false);
      return;
    }
    const validationResult = this.isValidPreconfig(this.dataPreconfig, this.isAggregateLines);
    if (!validationResult.isValid) {
        const errorMessage = validationResult.errors.join("\n• ");
        this.setErrorFromTxt(`Erreurs de validation :\n• ${errorMessage}`);
        console.error("Erreurs de validation des comptes :", validationResult.errors);
        this.$store.dispatch("login/setLoading", false);
        return;
    }
    this.updateAuthor();
    this.changeTypeCredit();
    this.changeTypeDebit();
    this.aggregateLines();
    this.addGroupe();
    const fecUrl = `withCredentials/fec/config/update?restaurant=${this.siteSelected.restaurantId}`;
    return axios
      .post(fecUrl, this.dataPreconfig)
      .then(() => {
        this.isUpdated = false;
        setTimeout(() => {
          this.onModifying = false;
          this.setSuccess(this.$t("Mise à jour réussie").toString());
        }, 1000);

        this.$store.dispatch("login/setLoading", false);
      })
      .catch((error) => {
        this.setErrorFromTxt(error.toString());
        console.error("Erreur lors du préconfig FEC :", error);
        this.$store.dispatch("login/setLoading", false);
      });
  }

  public async customExport(csvDownload: boolean, isSingleFile: boolean) {
    let start = new Date(this.filter.DATE_DEBUT);
    let end = new Date(this.filter.DATE_FIN);
    this.loading = true;
    this.dialogCsv = false;
    this.dialogTxt = false;

    if (start > end) {
      [start, end] = [end, start];
    }

    const exportDates: string[] = [];
    const current = moment(start);
    const endMoment = moment(end);

    while (current.isSameOrBefore(endMoment, "day")) {
      exportDates.push(current.format("YYYY-MM-DD"));
      current.add(1, "day");
    }

    let combinedData = "";
    let isHeaderIncluded = false;
    const errors: { date: string; message: string }[] = [];

    if (isSingleFile) {
      for (const date of exportDates) {
        try {
          const data = await this.downloadFecAndReturnData(
            date,
            this.siteSelected.restaurantId,
            csvDownload
          );
          const lines = data.split("\n");
          if (!isHeaderIncluded) {
            combinedData += lines[0] + "\n";
            isHeaderIncluded = true;
          }
          combinedData += lines.slice(1).join("\n");
        } catch (err) {
          const error = err as { date?: string; message?: string };
          errors.push({
            date: error.date || date,
            message: error.message || "Erreur inconnue",
          });
        }
      }

      if (combinedData.trim() !== "") {
        const formattedStart = start
          .toISOString()
          .split("T")[0]
          .replace(/-/g, "");
        const formattedEnd = end.toISOString().split("T")[0].replace(/-/g, "");
        this.saveToFile(
          combinedData,
          `${this.getSiren()}FEC${formattedStart}${formattedEnd}${
            csvDownload ? ".csv" : ".txt"
          }`
        );
      }
    } else {
      for (const date of exportDates) {
        try {
          await this.downloadFec(
            date,
            this.siteSelected.restaurantId,
            this.siteSelected.libelle,
            csvDownload
          );
        } catch (err) {
          const error = err as { date?: string; message?: string };
          errors.push({
            date: error.date || date,
            message: error.message || "Erreur inconnue",
          });
        }
      }
    }

    if (errors.length > 0) {
      const errorMessage = errors
        .map((e) => `📅 ${e.date} : ${e.message}`)
        .join("\n");
      this.setErrorFromTxt(errorMessage);
    }

    this.loading = false;
  }

  public async downloadFec(
    date: string,
    restaurantId: number,
    siteName: string,
    csvDownload: boolean
  ) {
    this.$store.dispatch("login/setLoading", true);
    const fecUrl = `withCredentials/fec/config/export?restaurant=${restaurantId}&dateFiscales=${date}&csvDownload=${csvDownload}`;
    const fileType = csvDownload ? ".csv" : ".txt";

    return axios
      .get(fecUrl, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        const formattedDates = date.replace(/-/g, "");
        link.href = url;
        link.setAttribute(
          "download",
          `${this.getSiren()}FEC${formattedDates}${fileType}`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$store.dispatch("login/setLoading", false);
      })
      .catch(async (error) => {
        this.$store.dispatch("login/setLoading", false);
        let errorMessage = "Erreur inconnue";
        if (
          error.response &&
          error.response.status === 500 &&
          error.response.data instanceof Blob
        ) {
          try {
            errorMessage = await error.response.data.text();
          } catch (e) {
            errorMessage = "Erreur lors de la lecture du message";
          }
        } else if (error.message) {
          errorMessage = error.message;
        }

        this.setErrorFromTxt(`📅 ${date} : ${errorMessage}`);

        throw { date, message: errorMessage };
      });
  }

  // Ces deux fonction récupère chaque donnée pour chaque journée
  // pour les mettre dans un fichier unique

  public async downloadFecAndReturnData(
    date: string,
    restaurantId: number,
    csvDownload: boolean
  ): Promise<string> {
    this.$store.dispatch("login/setLoading", true);
    const fecUrl = `withCredentials/fec/config/export?restaurant=${restaurantId}&dateFiscales=${date}&csvDownload=${csvDownload}`;
    return axios
      .get(fecUrl, { responseType: "blob" })
      .then((response) => {
        this.$store.dispatch("login/setLoading", false);
        return new Response(response.data).text();
      })
      .catch(async (error) => {
        this.$store.dispatch("login/setLoading", false);
        let errorMessage = "Erreur inconnue";
        if (
          error.response &&
          error.response.status === 500 &&
          error.response.data instanceof Blob
        ) {
          try {
            errorMessage = await error.response.data.text();
          } catch (e) {
            errorMessage = "Erreur lors de la lecture du message";
          }
        } else if (error.message) {
          errorMessage = error.message;
        }

        throw { date, message: errorMessage };
      });
  }

  public saveToFile(data: string, filename: string) {
    const blob = new Blob([data], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }

  public setCreditsMode(mode: string) {
    this.parLocalisation = false;
    this.isHTTVA = false;
    this.isSolidLiquid = false;
    this.isSolidLiquidProfit = false;

    switch (mode) {
      case "profit":
        this.parLocalisation = true;
        break;
      case "ht_tva":
        this.isHTTVA = true;
        break;
      case "solide_liquide":
        this.isSolidLiquid = true;
        break;
      case "solide_liquide_profit":
        this.isSolidLiquidProfit = true;
        break;
    }
  }

  public displayCreditMode() {
    if (this.parLocalisation) {
      return this.$t("ParProfit");
    }
    if (this.isHTTVA) {
      return "HT/TVA";
    }
    if (this.isSolidLiquid) {
      return "Sol/Liq";
    }
    if (this.isSolidLiquidProfit) {
      return "Sol/Liq/Profit";
    }
    return "HT/TVA";
  }

  public updateDate(date: DateType) {
    this.dateType = date;

    const today = moment().format("YYYY-MM-DD");
    const dateFin = moment(this.dateType.dateFin).format("YYYY-MM-DD");

    this.filter.DATE_DEBUT = moment(this.dateType.dateDebut).format("YYYY-MM-DD");

    if (moment(dateFin).isAfter(moment(today))) {
        this.filter.DATE_FIN = today;
        console.warn("Date de fin ajustée à aujourd'hui car elle était dans le futur");
    } else {
        this.filter.DATE_FIN = dateFin;
    }

    if (
        this.filter.DATE_FIN !== "Invalid date" &&
        this.filter.DATE_FIN !== this.filter.DATE_DEBUT
    ) {
        this.isMultipleDate = true;
    } else {
        this.isMultipleDate = false;
    }
    this.updatedSearchCrit = true;
    this.message = this.$t("Update").toString();
    this.dates[0] = this.filter.DATE_DEBUT;
  }

  public verrifComptage() {
    if (!this.dataPreconfig.comptage) {
      this.dataPreconfig.comptage = {
        libelle: "DIFFERENCE",
        compte: 850100,
        difference: "DIFFERENCE",
      };
    }
  }

  public getSiren(): string | undefined {
    return FecUtils.extractSiren(this.sirets, this.siteSelected.restaurantId);
  }

  public formatRate(rate: string): string {
    const cleanedRate = rate.replace(/[^\d.]/g, "");
    return parseFloat(cleanedRate).toFixed(1);
  }

  public isNotTVA(groupName: string | number): boolean {
    return groupName.toString() !== "TVA";
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get societes(): Societe[] {
    return this.$store.getters["config/societes"];
  }

  get groupements(): Groupe[] {
    const gpm = this.$store.getters["login/groupements"];
    return gpm;
  }

  get fecRestaurantId(): number {
    return this.$store.getters["config/fecRestaurantId"];
  }

  get enseignes(): any {
    return this.$store.getters["login/enseignes"];
  }

  get sirets(): any {
    return this.$store.getters["login/sirets"];
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }
}
